<template>
  <div>
    <div
      style="position: fixed; top: 20px; z-index: 1; backdrop-filter: blur(2px)"
      v-if="LoaderStatus"
    >
      <Spinner />
    </div>
    <div class="new-reports d-flex flex-column pb-2">
      <div class="new-reports-header py-2 px-3 d-flex align-items-center">
        <div class="title-nav d-flex align-items-center">
          <img
            src="../../assets/ReportsNew/goBack.svg"
            alt=""
            class="pointer"
            @click="goBack"
          />
          <span class="title">Customer Reports</span>
        </div>
      </div>
      <div class="overview-tab px-3 py-3">
        <span class="tab-title">Overview</span>
        <div class="overview-items-flex d-flex align-items-center flex-grow-1">
          <div class="overview-item">
            <span class="item-title">Total Customers</span>
            <span class="item-value">{{ totalCustCount }}</span>
          </div>
          <div class="overview-item">
            <span class="item-title">Total Jobs</span>
            <span class="item-value">{{ totalJobCount }}</span>
          </div>
          <div class="overview-item">
            <span class="item-title">Total Openings</span>
            <span class="item-value">{{ totalOpeningsCount }}</span>
          </div>
          <div class="overview-item">
            <span class="item-title">Total Selected Candidates</span>
            <span class="item-value">{{ totalSelectedCount }}</span>
          </div>
        </div>
      </div>

      <!-- Customers Table -->
      <div class="table-panel px-1">
        <div
          class="
            table-title-bar
            d-flex
            align-items-center
            justify-content-between
            px-3
            py-2
          "
        >
          <span class="table-title">Customers</span>
          <div class="search-export-options d-flex align-items-center">
            <div class="search-bar d-flex align-items-center px-3">
              <img src="../../assets/ReportsNew/searchIcon.svg" alt="" />

              <b-form-input
                type="search"
                class="mb-1"
                placeholder="Search Customers"
                v-model.trim="custSearchQuery"
                debounce="500"
                @update="getSearchCustData"
              />
            </div>
            <span class="active-customers"
              >Total Customers: {{ totalCustCount }}</span
            >
            <button
              type="button"
              class="export-excel px-4 py-1"
              @click="openExcel()"
            >
              Export Excel
            </button>
          </div>
        </div>
        <div class="custReport-main-table">
          <div class="mainCust-table-head">
            <div class="d-flex align-items-center" style="width: 20%">
              <span>Customer Name</span>
              <div class="sort-header p-1 ml-1 d-flex flex-column">
                <img
                  v-if="custSort != 'name'"
                  @click="sortData('name', 1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/nosort.svg"
                  alt
                />
                <img
                  v-else-if="custSort && custOrder == 1"
                  @click="sortData('name', -1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/ascSort.svg"
                  alt
                />
                <img
                  v-else-if="custSort && custOrder == -1"
                  @click="sortData('name', 1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/descSort.svg"
                  alt
                />
              </div>
            </div>
            <div class="d-flex align-items-center" style="width: 15%">
              <span>Coordinators</span>
            </div>
            <div class="d-flex align-items-center" style="width: 15%">
              <span>Active Jobs</span>
              <div class="sort-header p-1 ml-1 d-flex flex-column">
                <img
                  v-if="custSort != 'activeJobsCount'"
                  @click="sortData('activeJobsCount', 1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/nosort.svg"
                  alt
                />
                <img
                  v-else-if="custSort && custOrder == 1"
                  @click="sortData('activeJobsCount', -1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/ascSort.svg"
                  alt
                />
                <img
                  v-else-if="custSort && custOrder == -1"
                  @click="sortData('activeJobsCount', 1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/descSort.svg"
                  alt
                />
              </div>
            </div>
            <div class="d-flex align-items-center" style="width: 15%">
              <span>Closed Jobs</span>
              <div class="sort-header p-1 ml-1 d-flex flex-column">
                <img
                  v-if="custSort != 'closedJobsCount'"
                  @click="sortData('closedJobsCount', 1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/nosort.svg"
                  alt
                />
                <img
                  v-else-if="custSort && custOrder == 1"
                  @click="sortData('closedJobsCount', -1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/ascSort.svg"
                  alt
                />
                <img
                  v-else-if="custSort && custOrder == -1"
                  @click="sortData('closedJobsCount', 1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/descSort.svg"
                  alt
                />
              </div>
            </div>
            <div class="d-flex align-items-center" style="width: 15%">
              <span>Total Openings</span>
              <div class="sort-header p-1 ml-1 d-flex flex-column">
                <img
                  v-if="custSort != 'openingsCount'"
                  @click="sortData('openingsCount', 1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/nosort.svg"
                  alt
                />
                <img
                  v-else-if="custSort && custOrder == 1"
                  @click="sortData('openingsCount', -1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/ascSort.svg"
                  alt
                />
                <img
                  v-else-if="custSort && custOrder == -1"
                  @click="sortData('openingsCount', 1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/descSort.svg"
                  alt
                />
              </div>
            </div>
            <div class="d-flex align-items-center" style="width: 20%">
              <span>Total Selected Candidates</span>
              <div class="sort-header p-1 ml-1 d-flex flex-column">
                <img
                  v-if="custSort != 'selectedCandidatesCount'"
                  @click="sortData('selectedCandidatesCount', 1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/nosort.svg"
                  alt
                />
                <img
                  v-else-if="custSort && custOrder == 1"
                  @click="sortData('selectedCandidatesCount', -1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/ascSort.svg"
                  alt
                />
                <img
                  v-else-if="custSort && custOrder == -1"
                  @click="sortData('selectedCandidatesCount', 1)"
                  class="pointer"
                  src="../../assets/img/accessconnew/descSort.svg"
                  alt
                />
              </div>
            </div>
          </div>
          <div class="mainCust-table-body p-1" @scroll="custScroll">
            <template
              v-if="
                customerData.length == 0 &&
                custSearchQuery == '' &&
                !custMainLoader &&
                !checkCustScroll
              "
            >
              <div
                class="
                  d-flex
                  justify-content-center
                  align-items-center
                  mt-2
                  h-100
                  flex-column
                "
              >
                <div>
                  <img
                    src="../../assets/ReportsNew/no-reports-svg.svg"
                    alt=""
                  />
                </div>
                <div
                  class="no-matching-results-font mt-1 wordbreak text-center"
                >
                  No reports to show!
                </div>
              </div>
            </template>
            <template
              v-else-if="
                (customerData.length == 0 &&
                  custSearchQuery == '' &&
                  !checkCustScroll) ||
                custMainLoader
              "
            >
              <div
                style="margin: auto"
                class="d-flex justify-content-center align-items-center h-100"
              >
                <b-spinner label="Loading..."></b-spinner>
              </div>
            </template>

            <template
              v-else-if="customerData.length == 0 && custSearchQuery !== ''"
            >
              <div
                class="
                  d-flex
                  justify-content-center
                  align-items-center
                  mt-2
                  h-100
                  flex-column
                "
              >
                <div>
                  <img
                    src="../../assets/ReportsNew/panel-wrong-search.svg"
                    alt=""
                  />
                </div>
                <div
                  class="no-matching-results-font mt-1 wordbreak text-center"
                >
                  No matching results found for "{{ custSearchQuery }}"
                </div>
              </div>
            </template>
            <template v-else-if="customerData.length !== 0 && !custMainLoader">
              <div
                class="custReport-table-row pointer"
                v-for="(cust, custIndex) in customerData"
                :key="custIndex"
                @click="SelectRow(cust.name, cust.customerID)"
                :class="
                  selectedRow == cust.customerID ? 'cust-row-selected' : ''
                "
              >
                <span class="sideGridBlueColor"></span>
                <span class="text-truncate" style="width: 20%">
                  <span
                    v-b-tooltip.hover.top="cust.name"
                    class="d-inline-block text-truncate"
                    style="min-width: auto; max-width: 80%"
                  >
                    {{ cust.name }}
                  </span>
                </span>
                <span style="width: 15%">
                  <div
                    style="width: 35%"
                    class="d-flex align-items-center justify-content-center"
                  >
                    <div
                      class="
                        d-flex
                        align-items-center
                        justify-content-center
                        position-relative
                      "
                      :style="
                        cust.coOrdinatorDetails.length > 3
                          ? 'width: 100px'
                          : cust.coOrdinatorDetails.length == 3
                          ? 'width: 70px;'
                          : cust.coOrdinatorDetails.length == 2
                          ? 'width: 45px;'
                          : cust.coOrdinatorDetails.length == 1
                          ? 'width: 20px;'
                          : ''
                      "
                    >
                      <div
                        v-if="cust.coOrdinatorDetails.length > 0"
                        class="roundDarkBlue"
                        style="left: 0px"
                        v-b-tooltip.hover.top="cust.coOrdinatorDetails[0].name"
                      >
                        {{ cust.coOrdinatorDetails[0].userIcon }}
                      </div>
                      <div
                        v-if="cust.coOrdinatorDetails.length > 1"
                        class="roundDarkBlue"
                        style="left: 25px"
                        v-b-tooltip.hover.top="cust.coOrdinatorDetails[1].name"
                      >
                        {{ cust.coOrdinatorDetails[1].userIcon }}
                      </div>
                      <div
                        v-if="cust.coOrdinatorDetails.length > 2"
                        class="roundDarkBlue"
                        style="left: 50px"
                        v-b-tooltip.hover.top="cust.coOrdinatorDetails[2].name"
                      >
                        {{ cust.coOrdinatorDetails[2].userIcon }}
                      </div>
                      <div
                        v-if="cust.coOrdinatorDetails.length == 4"
                        class="roundDarkBlue"
                        style="left: 75px"
                        v-b-tooltip.hover.top="cust.coOrdinatorDetails[3].name"
                      >
                        {{ cust.coOrdinatorDetails[3].userIcon }}
                      </div>
                      <div
                        v-if="cust.coOrdinatorDetails.length > 4"
                        class="roundLightBlue"
                        style="left: 75px"
                        v-b-tooltip.hover.top="
                          getRemainingNamesTooltip(cust.coOrdinatorDetails)
                        "
                      >
                        +{{ cust.coOrdinatorDetails.length - 3 }}
                      </div>
                    </div>
                  </div>
                </span>
                <span style="width: 15%">{{ cust.activeJobsCount }}</span>
                <span style="width: 15%" class="pl-1">{{
                  cust.closedJobsCount
                }}</span>
                <span style="width: 15%" class="pl-1">{{
                  cust.openingsCount
                }}</span>
                <span style="width: 20%" class="pl-2">{{
                  cust.selectedCandidatesCount
                }}</span>
              </div>
              <div
                style="margin: auto"
                v-if="checkCustScroll"
                class="d-flex justify-content-center mt-2"
              >
                <b-spinner label="Loading..."></b-spinner>
              </div>
            </template>
          </div>
        </div>
      </div>

      <!-- Overall Reports Section -->
      <div ref="overallreport" class="overall-reports relativeclass">
        <div class="overall-reports-header d-flex align-items-end w-100">
          <div class="title-section d-flex flex-column" style="width: 75%">
            <span class="title">Overall Report</span>
            <span class="sub-title"
              >(Click on Customer Name to see their report)</span
            >
          </div>
          <div
            class="d-flex align-items-center"
            style="position: absolute; right: 0"
          >
            <div
              class="filter-section d-flex align-items-center pr-4"
              ref="filter"
              v-closable="{
                exclude: ['filter', 'filterdropdown'],
                handler: 'cancelFilterSection',
              }"
            >
              <div class="w-100 d-flex align-items-center justify-content-end">
                <div>Show Results for:</div>
                <div class="custom-dropdown pl-3">
                  <div
                    class="selected-filter d-flex align-items-center w-100"
                    @click="toggleReportsFilter"
                  >
                    <div class="text-truncate" style="width: 90px">
                      <div
                        class="d-inline-block text-truncate mt-1"
                        style="min-width: auto; max-width: 100%"
                      >
                        <template v-if="selectedRow == 'all'">
                          All Customers
                        </template>
                        <template v-else>
                          {{ selectedRowName }}
                        </template>
                      </div>
                    </div>
                    <div>
                      <img
                        src="../../assets/ReportsNew/chev_down_blue.svg"
                        alt=""
                      />
                    </div>
                  </div>
                  <div
                    class="filter-list-dropdown"
                    v-if="overallReportsFilter"
                    style="width: 250px"
                  >
                    <div class="filter-search">
                      <img
                        src="../../assets/ReportsNew/searchIcon.svg"
                        alt=""
                      />
                      <b-form-input
                        type="search"
                        name="overallReportsSearch"
                        id="overallReportsSearch"
                        placeholder="Search"
                        v-model.trim="overAllSearchQuery"
                        debounce="500"
                        @update="getsearchedoverAll"
                      />
                    </div>
                    <div class="filter-list w-100" @scroll="scrollOverAllCust">
                      <template
                        v-if="
                          (overAllCustData.length == 0 &&
                            overAllSearchQuery == '' &&
                            !checkoverAllScrollLoader) ||
                          showOverAllLoader
                        "
                      >
                        <div
                          style="margin: auto"
                          class="
                            d-flex
                            justify-content-center
                            align-items-center
                            mt-2
                            h-100
                          "
                        >
                          <b-spinner label="Loading..."></b-spinner>
                        </div>
                      </template>
                      <template
                        v-if="overAllCustData.length == 0 && !showOverAllLoader"
                      >
                        <div
                          class="
                            no-matching-results-font
                            mt-1
                            wordbreak
                            text-center
                          "
                        >
                          No Records found
                        </div>
                      </template>
                      <template
                        v-else-if="
                          overAllCustData.length !== 0 && !showOverAllLoader
                        "
                      >
                        <div
                          v-if="overAllSearchQuery == ''"
                          class="pointer"
                          @click="selectAllCustRow"
                          :class="
                            selectedRow == 'all' ? 'cust-row-selected' : ''
                          "
                        >
                          All Customers
                        </div>
                        <div
                          class="w-100 wordbreak pointer"
                          v-for="(over, overIndex) in overAllCustData"
                          :key="overIndex"
                          @click="SelectOverallRow(over.name, over.customerID)"
                          :class="
                            selectedRow == over.customerID
                              ? 'cust-row-selected'
                              : ''
                          "
                        >
                          {{ over.name }}
                        </div>
                        <div
                          v-if="checkoverAllScrollLoader"
                          style="margin: auto"
                          class="
                            d-flex
                            justify-content-center
                            align-items-center
                            mt-2
                          "
                        >
                          <b-spinner label="Loading..."></b-spinner>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <img
                src="../../assets/New-imgs/CustVend-icons/newreports-line.svg"
                alt=""
              />
            </div>
            <div class="daily-option pl-4">
              <button
                type="button"
                class="d-flex align-items-center"
                @click.stop="openDurationList"
              >
                <span>{{ DisplayTimeline }}</span>
                <img src="../../assets/ReportsNew/chev_down_blue.svg" alt="" />
              </button>
              <div
                class="report-duration-dropdown"
                style="margin-top: 2px"
                v-if="durationListOpen"
                ref="dropdown1"
              >
                <div
                  class="duration-item pointer"
                  :style="
                    this.timeline == 'today' || this.storeTimeline == 'today'
                      ? 'background: #c8d9e5'
                      : ''
                  "
                  @click="setTimeline('today')"
                >
                  Today
                </div>
                <div
                  class="duration-item pointer"
                  :style="
                    this.timeline == 'thisWeek' ||
                    this.storeTimeline == 'thisWeek'
                      ? 'background: #c8d9e5'
                      : ''
                  "
                  @click="setTimeline('thisWeek')"
                >
                  This Week
                </div>
                <div
                  class="duration-item pointer"
                  :style="
                    this.timeline == 'thisMonth' ||
                    this.storeTimeline == 'thisMonth'
                      ? 'background: #c8d9e5'
                      : ''
                  "
                  @click="setTimeline('thisMonth')"
                >
                  This Month
                </div>
                <div
                  class="duration-item pointer"
                  :style="
                    this.timeline == 'thisYear' ||
                    this.storeTimeline == 'thisYear'
                      ? 'background: #c8d9e5'
                      : ''
                  "
                  @click="setTimeline('thisYear')"
                >
                  This Year
                </div>
                <div
                  class="duration-item custom p-0"
                  :style="
                    this.timeline == 'custom' && this.appliedFilter
                      ? 'background: #c8d9e5'
                      : ''
                  "
                  @click="setTimeline('custom')"
                >
                  <div
                    class="
                      d-flex
                      align-items-center
                      justify-content-between
                      pointer
                    "
                    @click.stop="customDurationOpen = !customDurationOpen"
                    style="padding: 8px 10px"
                  >
                    <span>Custom</span>
                    <img
                      src="../../assets/ReportsNew/chevron_right.svg"
                      alt=""
                      style="height: 8px"
                    />
                  </div>

                  <div
                    class="custom-duration-menu p-3"
                    v-if="customDurationOpen"
                    ref="dropdown2"
                  >
                    <span class="custom-title">Custom View</span>
                    <div class="topDiv mt-3">
                      <DateField
                        :type="'date'"
                        :label="'From Date'"
                        :mandatory="false"
                        :placeholder="'Choose From Date'"
                        :id="'fromDate'"
                        :vmodel="fromDate"
                        :format="'DD-MM-YYYY'"
                        @select-value="fromDate = $event"
                      />
                    </div>
                    <div class="topDiv mt-3">
                      <DateField
                        :type="'date'"
                        :label="'To Date'"
                        :mandatory="false"
                        :placeholder="'Choose To Date'"
                        :id="'toDate'"
                        :format="'DD-MM-YYYY'"
                        :vmodel="toDate"
                        @select-value="toDate = $event"
                        :startDate="fromDate"
                      />
                    </div>
                    <div class="topDiv mt-3">
                      <DateField
                        :type="'time'"
                        :label="'Start Time'"
                        :mandatory="false"
                        :placeholder="'Choose Start Time'"
                        :id="'startPanTime'"
                        :format="'HH:mm:ss'"
                        :vmodel="startTime"
                        @select-value="startTime = $event"
                        :disabled="fromDate == '' && toDate == ''"
                        icon="time"
                      />
                    </div>
                    <div class="topDiv mt-3">
                      <DateField
                        :type="'time'"
                        :label="'End time'"
                        :mandatory="false"
                        :placeholder="'Choose End Time'"
                        :id="'endPanTime'"
                        :format="'HH:mm:ss'"
                        :vmodel="endTime"
                        @select-value="endTime = $event"
                        :disabled="fromDate == '' && toDate == ''"
                        icon="time"
                      />
                    </div>

                    <div class="d-flex justify-content-between mt-4 bluebtn">
                      <b-button
                        class="acs-cancelBtn-filter"
                        @click="cancelCustom"
                        >Cancel</b-button
                      >
                      <div class="d-flex">
                        <b-button
                          class="acs-cancelBtn-filter mr-3"
                          :disabled="fromDate == '' && toDate == ''"
                          @click="resetCustom"
                          >Reset</b-button
                        >
                        <b-button
                          class="acs-cancelBtn-filter"
                          :disabled="fromDate == '' && toDate == ''"
                          @click="applyCustom"
                          >Apply</b-button
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Job Statistics Table -->
        <div class="table-panel wide-table px-1">
          <div
            class="
              table-title-bar
              d-flex
              align-items-center
              justify-content-between
              px-3
              py-2
            "
          >
            <span class="table-title">Job Statistics</span>
            <div class="search-export-options d-flex align-items-center">
              <div class="search-bar d-flex align-items-center px-3">
                <img src="../../assets/ReportsNew/searchIcon.svg" alt="" />
                <b-form-input
                  type="search"
                  class="mb-1"
                  placeholder="Search Jobs"
                  debounce="500"
                  @update="updateJobsData"
                  v-model.trim="statsSearchQuery"
                />
              </div>
              <span class="active-customers"
                >Total Jobs: {{ totalJobsCount }}</span
              >
              <div
                ref="mainFilterClosable"
                v-closable="{
                  exclude: ['mainFilterClosable', 'mainFilterClosabledropdown'],
                  handler: 'closemainFilterClosableFilter',
                }"
              >
                <button
                  type="button"
                  class="filter px-4 py-1 d-flex align-items-center"
                  @click="toggleMainFilter"
                >
                  <img src="../../assets/ReportsNew/filter_icon.svg" alt="" />
                  Filter
                </button>
                <div class="filter-popup" v-if="mainFilter">
                  <div class="mt-3">
                    <div class="acs-black-txt">Job Type:</div>
                    <div
                      @click="jobTypeToggle = !jobTypeToggle"
                      class="acs-filter-dropdown mt-2 position-relative pointer"
                    >
                      <span class="newManage-dropdown-place">
                        {{
                          jobType === "closed"
                            ? "Closed"
                            : jobType === "active"
                            ? "Active"
                            : "All"
                        }}
                      </span>
                      <img
                        src="../../assets/img/accessconnew/blueDownArrowSmall.svg"
                        alt=""
                      />
                    </div>
                    <div v-if="jobTypeToggle" class="relativeclass">
                      <div class="newInt-radio-dropdown p-0">
                        <b-form-group class="sec-mcq-datacard">
                          <b-form-radio-group
                            class="newInt-radio-dropdown-inner-content w-100"
                            size="sm"
                            v-model="jobType"
                            :options="jobOptions"
                            @change="jobTypeToggle = false"
                            buttons
                            stacked
                          >
                          </b-form-radio-group>
                        </b-form-group>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex justify-content-between mt-4 bluebtn">
                    <b-button class="acs-cancelBtn-filter" @click="cancelFilter"
                      >Cancel</b-button
                    >
                    <div class="d-flex">
                      <b-button
                        class="acs-cancelBtn-filter mr-3"
                        @click="resetFilter"
                        >Reset</b-button
                      >
                      <b-button
                        class="acs-cancelBtn-filter"
                        @click="applyFilter"
                        >Apply</b-button
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="custReport-main-table">
            <div class="custReport-table-head">
              <div class="d-flex align-items-center" style="width: 15%">
                <span>Job Name</span>
                <div class="sort-header p-1 ml-1 d-flex flex-column">
                  <img
                    v-if="statsSort != 'jobName'"
                    @click="sortCustStatsData('jobName', 1)"
                    class="pointer"
                    src="../../assets/img/accessconnew/nosort.svg"
                    alt
                  />
                  <img
                    v-else-if="statsSort && statsOrder == 1"
                    @click="sortCustStatsData('jobName', -1)"
                    class="pointer"
                    src="../../assets/img/accessconnew/ascSort.svg"
                    alt
                  />
                  <img
                    v-else-if="statsSort && statsOrder == -1"
                    @click="sortCustStatsData('jobName', 1)"
                    class="pointer"
                    src="../../assets/img/accessconnew/descSort.svg"
                    alt
                  />
                </div>
              </div>
              <div class="d-flex align-items-center" style="width: 10%">
                <span>Age <i>(in days)</i></span>
                <div class="sort-header p-1 ml-1 d-flex flex-column">
                  <img
                    v-if="statsSort != 'jobAge'"
                    @click="sortCustStatsData('jobAge', 1)"
                    class="pointer"
                    src="../../assets/img/accessconnew/nosort.svg"
                    alt
                  />
                  <img
                    v-else-if="statsSort && statsOrder == 1"
                    @click="sortCustStatsData('jobAge', -1)"
                    class="pointer"
                    src="../../assets/img/accessconnew/ascSort.svg"
                    alt
                  />
                  <img
                    v-else-if="statsSort && statsOrder == -1"
                    @click="sortCustStatsData('jobAge', 1)"
                    class="pointer"
                    src="../../assets/img/accessconnew/descSort.svg"
                    alt
                  />
                </div>
              </div>
              <div class="d-flex align-items-center" style="width: 10%">
                <span>No. of Openings</span>
                <div class="sort-header p-1 ml-1 d-flex flex-column">
                  <img
                    v-if="statsSort != 'openingsCount'"
                    @click="sortCustStatsData('openingsCount', 1)"
                    class="pointer"
                    src="../../assets/img/accessconnew/nosort.svg"
                    alt
                  />
                  <img
                    v-else-if="statsSort && statsOrder == 1"
                    @click="sortCustStatsData('openingsCount', -1)"
                    class="pointer"
                    src="../../assets/img/accessconnew/ascSort.svg"
                    alt
                  />
                  <img
                    v-else-if="statsSort && statsOrder == -1"
                    @click="sortCustStatsData('openingsCount', 1)"
                    class="pointer"
                    src="../../assets/img/accessconnew/descSort.svg"
                    alt
                  />
                </div>
              </div>
              <div class="d-flex align-items-center" style="width: 15%">
                <span>Candidates Added</span>
                <div class="sort-header p-1 ml-1 d-flex flex-column">
                  <img
                    v-if="statsSort != 'candidatesAddedCount'"
                    @click="sortCustStatsData('candidatesAddedCount', 1)"
                    class="pointer"
                    src="../../assets/img/accessconnew/nosort.svg"
                    alt
                  />
                  <img
                    v-else-if="statsSort && statsOrder == 1"
                    @click="sortCustStatsData('candidatesAddedCount', -1)"
                    class="pointer"
                    src="../../assets/img/accessconnew/ascSort.svg"
                    alt
                  />
                  <img
                    v-else-if="statsSort && statsOrder == -1"
                    @click="sortCustStatsData('candidatesAddedCount', 1)"
                    class="pointer"
                    src="../../assets/img/accessconnew/descSort.svg"
                    alt
                  />
                </div>
              </div>
              <div class="d-flex align-items-center" style="width: 15%">
                <span>Candidates Selected</span>
                <div class="sort-header p-1 ml-1 d-flex flex-column">
                  <img
                    v-if="statsSort != 'selectedCandidatesCount'"
                    @click="sortCustStatsData('selectedCandidatesCount', 1)"
                    class="pointer"
                    src="../../assets/img/accessconnew/nosort.svg"
                    alt
                  />
                  <img
                    v-else-if="statsSort && statsOrder == 1"
                    @click="sortCustStatsData('selectedCandidatesCount', -1)"
                    class="pointer"
                    src="../../assets/img/accessconnew/ascSort.svg"
                    alt
                  />
                  <img
                    v-else-if="statsSort && statsOrder == -1"
                    @click="sortCustStatsData('selectedCandidatesCount', 1)"
                    class="pointer"
                    src="../../assets/img/accessconnew/descSort.svg"
                    alt
                  />
                </div>
              </div>
              <div class="d-flex align-items-center" style="width: 10%">
                <span>Selection Rate</span>
                <div class="sort-header p-1 ml-1 d-flex flex-column">
                  <img
                    v-if="statsSort != 'selectionRate'"
                    @click="sortCustStatsData('selectionRate', 1)"
                    class="pointer"
                    src="../../assets/img/accessconnew/nosort.svg"
                    alt
                  />
                  <img
                    v-else-if="statsSort && statsOrder == 1"
                    @click="sortCustStatsData('selectionRate', -1)"
                    class="pointer"
                    src="../../assets/img/accessconnew/ascSort.svg"
                    alt
                  />
                  <img
                    v-else-if="statsSort && statsOrder == -1"
                    @click="sortCustStatsData('selectionRate', 1)"
                    class="pointer"
                    src="../../assets/img/accessconnew/descSort.svg"
                    alt
                  />
                </div>
              </div>
              <div class="d-flex align-items-center" style="width: 10%">
                <span>Rejection Rate</span>
                <div class="sort-header p-1 ml-1 d-flex flex-column">
                  <img
                    v-if="statsSort != 'rejectionRate'"
                    @click="sortCustStatsData('rejectionRate', 1)"
                    class="pointer"
                    src="../../assets/img/accessconnew/nosort.svg"
                    alt
                  />
                  <img
                    v-else-if="statsSort && statsOrder == 1"
                    @click="sortCustStatsData('rejectionRate', -1)"
                    class="pointer"
                    src="../../assets/img/accessconnew/ascSort.svg"
                    alt
                  />
                  <img
                    v-else-if="statsSort && statsOrder == -1"
                    @click="sortCustStatsData('rejectionRate', 1)"
                    class="pointer"
                    src="../../assets/img/accessconnew/descSort.svg"
                    alt
                  />
                </div>
              </div>
              <div class="d-flex align-items-center" style="width: 20%">
                <span>Tagged</span>
              </div>
              <div class="d-flex align-items-center" style="width: 15%">
                <span>Time To Fill <i>(in days)</i></span>
                <div class="sort-header p-1 ml-1 d-flex flex-column">
                  <img
                    v-if="statsSort != 'timeToFill'"
                    @click="sortCustStatsData('timeToFill', 1)"
                    class="pointer"
                    src="../../assets/img/accessconnew/nosort.svg"
                    alt
                  />
                  <img
                    v-else-if="statsSort && statsOrder == 1"
                    @click="sortCustStatsData('timeToFill', -1)"
                    class="pointer"
                    src="../../assets/img/accessconnew/ascSort.svg"
                    alt
                  />
                  <img
                    v-else-if="statsSort && statsOrder == -1"
                    @click="sortCustStatsData('timeToFill', 1)"
                    class="pointer"
                    src="../../assets/img/accessconnew/descSort.svg"
                    alt
                  />
                </div>
              </div>
            </div>

            <div class="custReport-table-body p-1" @scroll="statsScroll">
              <template
                v-if="
                  (statsData.length == 0 &&
                    statsSearchQuery == '' &&
                    !checkStatsScroll &&
                    !checkTimeLineData) ||
                  statsMainLoader
                "
              >
                <div
                  style="margin: auto"
                  class="d-flex justify-content-center align-items-center h-100"
                >
                  <b-spinner label="Loading..."></b-spinner>
                </div>
              </template>
              <template
                v-else-if="
                  statsData.length == 0 &&
                  checkTimeLineData &&
                  statsSearchQuery == ''
                "
              >
                <div
                  class="
                    d-flex
                    justify-content-center
                    align-items-center
                    h-100
                    flex-column
                  "
                >
                  <div>
                    <img
                      src="../../assets/ReportsNew/no-reports-svg.svg"
                      alt=""
                    />
                  </div>
                  <div
                    class="no-matching-results-font mt-1 wordbreak text-center"
                  >
                    No reports to show!
                  </div>
                </div>
              </template>
              <template
                v-else-if="statsData.length == 0 && statsSearchQuery !== ''"
              >
                <div
                  class="
                    d-flex
                    justify-content-center
                    align-items-center
                    mt-2
                    h-100
                    flex-column
                  "
                >
                  <div>
                    <img
                      src="../../assets/ReportsNew/panel-wrong-search.svg"
                      alt=""
                    />
                  </div>
                  <div
                    class="no-matching-results-font mt-1 wordbreak text-center"
                  >
                    No matching results found for "{{ statsSearchQuery }}"
                  </div>
                </div>
              </template>
              <template v-else-if="statsData.length !== 0 && !statsMainLoader">
                <div
                  class="custReport-table-row w-100"
                  v-for="(stats, statIndex) in statsData"
                  :key="statIndex"
                >
                  <span
                    v-if="stats.typeOfJob == 'active'"
                    class="sideGridGreenColor"
                  ></span>
                  <span
                    v-if="stats.typeOfJob == 'closed'"
                    class="sideGridRedColor"
                  ></span>

                  <span class="text-truncate" style="width: 15%">
                    <span
                      v-b-tooltip.hover.top="stats.jobName"
                      class="d-inline-block text-truncate"
                      style="min-width: auto; max-width: 80%"
                    >
                      {{ stats.jobName }}
                    </span>
                  </span>
                  <span style="width: 10%">{{ stats.jobAge }}</span>
                  <span style="width: 10%">{{ stats.openingsCount }}</span>
                  <span style="width: 15%">{{
                    stats.candidatesAddedCount
                  }}</span>
                  <span style="width: 15%" class="pl-1">{{
                    stats.selectedCandidatesCount
                  }}</span>
                  <span style="width: 10%" class="pl-1"
                    >{{ stats.selectionRate }}%</span
                  >
                  <span style="width: 10%" class="pl-1"
                    >{{ stats.rejectionRate }}%</span
                  >
                  <span style="width: 20%" class="pl-1"
                    >Recruiters: {{ stats.recruitersCount }}
                    <span class="px-2"> | </span>
                    Vendor: {{ stats.vendorsCount }}</span
                  >
                  <span style="width: 15%" class="pl-1">
                    <template v-if="stats.timeToFill == null"> - </template>
                    <template v-else>
                      {{ stats.timeToFill }}
                    </template>
                  </span>
                </div>
                <div
                  style="margin: auto"
                  v-if="checkStatsScroll"
                  class="d-flex justify-content-center mt-2"
                >
                  <b-spinner label="Loading..."></b-spinner>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div class="overall-reports-flex w-100">
          <div class="overall-reports-item px-1" style="width: 33%">
            <div class="report-title px-3 py-2">
              <span class="title">Selection Summary</span>
            </div>
            <div class="report-content p-2">
              <div
                style="position: relative; top: 105px"
                v-if="selectionLoader"
                class="d-flex justify-content-center align-items-center h-100"
              >
                <b-spinner label="Loading..."></b-spinner>
              </div>

              <div
                v-else-if="!selectionLoader && noSelectionData"
                style="position: relative; top: 60px"
                class="
                  d-flex
                  align-items-center
                  justify-content-center
                  w-100
                  h-100
                "
              >
                <img
                  src="../../assets/ReportsNew/thirdPartyNodata.svg"
                  alt=""
                />
              </div>
              <div
                v-else
                style="position: relative; top: 60px"
                id="customerSelection"
              ></div>
              <div
                v-if="!noSelectionData"
                class="sample-legend-selection d-flex flex-column"
              >
                <div
                  class="legend-item d-flex align-items-center"
                  v-for="(gData, ind) in selectionSummaryGraphData"
                  :key="ind + 'selec'"
                >
                  <span
                    class="color-disc"
                    :style="{ backgroundColor: gData.clrCode }"
                  ></span>
                  <span class="item-name">{{ gData.name }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="overall-reports-item px-1" style="width: 33%">
            <div class="report-title px-3 py-2">
              <span class="title">Source</span>
            </div>
            <div class="report-content p-2">
              <div
                style="position: relative; top: 105px"
                v-if="SourceLoader"
                class="d-flex justify-content-center align-items-center h-100"
              >
                <b-spinner label="Loading..."></b-spinner>
              </div>
              <div
                v-if="noSourceData && !SourceLoader"
                style="position: relative; top: 60px"
                class="
                  d-flex
                  align-items-center
                  justify-content-center
                  w-100
                  h-100
                "
              >
                <img
                  src="../../assets/ReportsNew/roleDistributionNoData.svg"
                  alt=""
                />
              </div>

              <div v-else id="sourceGraph"></div>
              <div
                v-if="!noSourceData && !SourceLoader"
                class="sample-legend d-flex flex-column"
              >
                <div
                  class="legend-item d-flex align-items-center"
                  v-for="(gData2, ind) in sourceGraphData"
                  :key="ind + 'source'"
                >
                  <span
                    class="color-disc"
                    :style="{ backgroundColor: gData2.clrCode }"
                  ></span>
                  <span class="item-name">{{
                    gData2.roleName != null ? capitalize(gData2.roleName) : ""
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="overall-reports-item px-1" style="width: 33%">
            <div
              class="
                report-title
                px-3
                py-2
                d-flex
                align-items-center
                justify-content-between
              "
            >
              <span class="title">Assessments Taken</span>
              <span class="sub-title"
                >Total Assessments: {{ overallCountAssessment }}</span
              >
            </div>

            <div
              style="margin: auto"
              v-if="asessLoader"
              class="
                d-flex
                justify-content-center
                align-items-center
                h-100
                report-content
              "
            >
              <b-spinner label="Loading..."></b-spinner>
            </div>

            <div
              v-else-if="overallCountAssessment < 1 && !asessLoader"
              style="position: relative"
              class="
                report-content
                d-flex
                align-items-center
                justify-content-center
                w-100
                h-100
              "
            >
              <img
                src="../../assets/ReportsNew/roleDistributionNoData.svg"
                alt=""
              />
            </div>

            <div
              v-else
              class="report-content p-2 assesGraph"
              id="assesmentTakenGraph"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getCustomerReports,
  getCustomerStats,
  getSourceGraph,
  getAssesGraph,
  getCustomerReportsExcel,
  getCustomerReportsSelection,
} from "../../utils/apiFunctions.js";
import DateField from "../../components/InputComponents/DateField";
import {
  selectionSummaryGraph,
  rolePieChart,
  horizontalScroll,
} from "vue-d3-charts-hire3x";
import Spinner from "../../components/fixedcomponents/Spinner.vue";

export default {
  name: "CustomerReports",
  data() {
    return {
      isExcelBoolean: false,
      listSize: 40,
      skillListOpen: false,
      durationListOpen: false,
      customDurationOpen: false,
      jobFilter: false,

      timeline: "thisMonth",
      storeTimeline: "thisMonth",
      fromDate: "",
      toDate: "",
      startTime: "",
      endTime: "",
      appliedFilter: false,
      storeFromDate: "",
      storeToDate: "",
      storeStartTime: "",
      storeEndTime: "",
      selectedRow: "all",
      selectedRowName: "",
      selectedCustID: null,

      // customer variable starts from here
      custCount: 10,
      custPage: 0,
      custSort: "createdAt",
      custOrder: -1,
      custSearchQuery: "",
      customerData: [],
      totalSelectedCount: null,
      totalOpeningsCount: null,
      totalJobCount: null,
      totalCustCount: null,
      checkCustScroll: false,
      custTotal: null,
      custPageEnd: null,
      custMainLoader: false,

      // statistics variable
      statsCount: 10,
      statsPage: 0,
      statsSort: "createdAt",
      statsOrder: -1,
      statsSearchQuery: "",
      statsData: [],
      jobType: "",
      jobOptions: [
        { text: "All", value: "" },
        { text: "Active", value: "active" },
        { text: "Closed", value: "closed" },
      ],
      mainFilter: false,
      jobTypeToggle: false,
      appliedFilted: false,
      storeTypeSelected: "",
      checkStatsScroll: false,
      statsPageEnd: null,
      statsTotal: null,
      totalJobsCount: null,
      statsMainLoader: false,

      //Graph Variables
      selectionSummaryGraphData: [],
      sourceGraphData: [],
      noSelectionData: true,
      noSourceData: true,
      overallCountAssessment: null,

      // overall variables
      overAllSearchQuery: "",
      overAllCustData: [],
      showOverAllLoader: false,
      overallReportsFilter: false,
      overAllSort: "createdAt",
      overAllCount: 10,
      overAllCustPage: 0,
      overAllOrder: -1,
      overAllCustTotal: null,
      overAllCustPageEnd: null,
      checkoverAllScrollLoader: false,
      LoaderStatus: false,
      selectionLoader: true,
      SourceLoader: true,
      asessLoader: true,
    };
  },
  components: {
    DateField,
    Spinner,
  },
  created() {
    this.LoaderStatus = true;
    this.custMainLoader = true;
    this.getCustData();
    this.statsMainLoader = true;
    this.getCustStats();
    this.selectionCustomerReports();
    this.sourceCustomerReport();
    this.assessmentTakenGraph();
  },
  computed: {
    DisplayTimeline() {
      if (this.timeline == "today" || this.storeTimeline == "today") {
        return "Today";
      } else if (
        this.timeline == "thisWeek" ||
        this.storeTimeline == "thisWeek"
      ) {
        return "This Week";
      } else if (
        this.timeline == "thisYear" ||
        this.storeTimeline == "thisYear"
      ) {
        return "This Year";
      } else if (this.timeline == "custom" && this.appliedFilter) {
        return "Custom";
      } else if (
        this.timeline == "thisMonth" ||
        this.storeTimeline == "thisMonth"
      ) {
        return "This Month";
      } else {
        return this.storeTimeline;
      }
    },
    checkTimeLineData() {
      return (
        this.timeline == "today" ||
        this.timeline == "thisWeek" ||
        this.timeline == "thisYear" ||
        this.timeline == "thisMonth" ||
        this.timeline == "custom"
      );
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    scrollToDiv() {
      this.$refs.overallreport.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    },
    convertDateFormat(dateStr) {
      if (dateStr) {
        const [day, month, year] = dateStr.split("-");
        return `${year}-${month}-${day}`;
      } else {
        return "";
      }
    },
    handleClickOutside(event) {
      let picker = document.getElementsByClassName("mx-datepicker-main")[0];
      let timeItem = event.target.closest("li.mx-time-item");
      let dropdown = this.$refs.dropdown1;
      if (
        !picker?.contains(event.target) &&
        !dropdown?.contains(event.target) &&
        !timeItem
      ) {
        this.fromDate = this.storeFromDate;
        this.toDate = this.storeToDate;
        this.startTime = this.storeStartTime;
        this.endTime = this.storeEndTime;
        this.durationListOpen = false;
        this.customDurationOpen = false;
        if (!this.appliedFilter) {
          this.appliedFilter = false;
        }
      }
    },
    getRemainingNamesTooltip(coOrdinatorDetails) {
      const remainingNames = coOrdinatorDetails
        .slice(3)
        .map((coordinator) => coordinator.name);
      return remainingNames.join(", ");
    },
    openExcel() {
      this.isExcelBoolean = true;
      this.LoaderStatus = true;
      this.getExcel();
    },
    async getExcel() {
      try {
        let payload = {
          excel: this.isExcelBoolean,
          sortBy: this.custSort,
          order: this.custOrder,
        };
        const res = await getCustomerReportsExcel(payload);
        if (res.status == 200) {
          this.LoaderStatus = false;
          // window.open(res.data.Detail.file);
          const href = URL.createObjectURL(res.data);

          // create "a" HTML element with href to file & click
          const link = document.createElement("a");
          link.href = href;
          link.setAttribute("download", `Customer Reports.xlsx`);

          document.body.appendChild(link);
          link.click();

          // clean up "a" element & remove ObjectURL
          document.body.removeChild(link);
          URL.revokeObjectURL(href);
        }
      } catch (err) {
        console.error(err);
      }
    },
    //Reports
    capitalize(text) {
      return text.replace(
        /(?:^|_)([a-z])/g,
        (match, char) => " " + char.toUpperCase()
      );
    },
    areAllCountsZero(data, property) {
      return data.every((item) => item[property] === 0);
    },

    async selectionCustomerReports() {
      if (
        document.getElementById("customerSelection") &&
        document.getElementById("customerSelection").innerHTML != ""
      ) {
        document.getElementById("customerSelection").innerHTML = "";
      }
      this.selectionLoader = true;

      try {
        let payload = {
          page: 0,
          order: -1,
          count: 10,
          sortBy: "createdAt",
          searchQuery: "",
          timeline: this.timeline,
          startDate: this.convertDateFormat(this.fromDate),
          endDate: this.convertDateFormat(this.toDate),
          startTime: this.startTime,
          endTime: this.endTime,
        };
        if (this.selectedCustID !== "") {
          payload.customerID = this.selectedCustID;
        }
        const res = await getCustomerReportsSelection(payload);
        if (res.status == 200) {
          const selectionData = Object.values(res.data.data);
          this.noSelectionData = this.areAllCountsZero(
            selectionData,
            "totalOpeningsCount"
          );

          this.selectionSummaryGraphData = [
            {
              name: "Number of openings",
              count: res.data.data.totalOpeningsCount,
              clrCode: "#F5D06E",
            },
            {
              name: "Selected Candidates",
              count: res.data.data.totalSelectedCandidatesCount,
              clrCode: "#269C8A",
            },
          ];
          const clrScale = ["#F5D06E", "#269C8A", "#AD1927"];
          setTimeout(() => {
            if (document.getElementById("customerSelection").innerHTML != "") {
              document.getElementById("customerSelection").innerHTML = "";
            }
            const selectionChart = new selectionSummaryGraph();
            selectionChart.horizontalBarGraph(
              "#customerSelection",
              clrScale,
              this.selectionSummaryGraphData
            );
          }, 200);
        }
      } catch (error) {
        console.error(error);
      }
      this.selectionLoader = false;
    },
    async sourceCustomerReport() {
      if (
        document.getElementById("sourceGraph") &&
        document.getElementById("sourceGraph").innerHTML != ""
      ) {
        document.getElementById("sourceGraph").innerHTML = "";
      }
      this.SourceLoader = true;
      try {
        let payload = {
          timeline: this.timeline,
          startDate: this.convertDateFormat(this.fromDate),
          endDate: this.convertDateFormat(this.toDate),
          startTime: this.startTime,
          endTime: this.endTime,
        };
        if (this.selectedCustID !== "") {
          payload.customerID = this.selectedCustID;
        }
        const res = await getSourceGraph(payload);
        if (res.status == 200) {
          const fixData = res.data.data.sources;
          const clrScale = [
            "#4070EA",
            "#F5D06E",
            "#038E00",
            "#AD1927",
            "#595959",
            "#269C8A",
          ];
          this.sourceGraphData = fixData.map((d, i) => {
            return {
              roleName: d.text,
              percentage: d.percentage,
              clrCode: clrScale[i],
              count: d.count,
            };
          });
          this.noSourceData = this.areAllCountsZero(
            this.sourceGraphData,
            "percentage"
          );
          const margin = { top: 50, right: 180, bottom: 70, left: 70 };
          //  const start_point = margin.right;

          setTimeout(() => {
            if (document.getElementById("sourceGraph").innerHTML != "") {
              document.getElementById("sourceGraph").innerHTML = "";
            }
            let pieChart = new rolePieChart();
            pieChart.pieGraph(
              "#sourceGraph",
              "sourceGraph",
              this.sourceGraphData,
              margin
            );
          }, 200);
        }
      } catch (error) {
        console.error(error);
      }
      this.SourceLoader = false;
    },
    async assessmentTakenGraph() {
      if (
        document.getElementById("assesmentTakenGraph") &&
        document.getElementById("assesmentTakenGraph").innerHTML != ""
      ) {
        document.getElementById("assesmentTakenGraph").innerHTML = "";
      }
      this.asessLoader = true;

      try {
        let payload = {
          timeline: this.timeline,
          startDate: this.convertDateFormat(this.fromDate),
          endDate: this.convertDateFormat(this.toDate),
          startTime: this.startTime,
          endTime: this.endTime,
        };
        let full_data2;
        if (this.selectedCustID !== "") {
          payload.customerID = this.selectedCustID;
        }
        const resp = await getAssesGraph(payload);
        if (resp.status == 200) {
          full_data2 = resp.data.data.dates;
          this.overallCountAssessment = resp.data.data.overallCount;
          setTimeout(() => {
            document.getElementById("assesmentTakenGraph").innerHTML = "";
            let assessGraph = new horizontalScroll();
            assessGraph.verticalBar("#assesmentTakenGraph", full_data2);
          }, 200);
          // max2 = Math.max(...full_data2.map((o) => o.count));
          // allBarData2 = resp.data.data.dates;
          // xScaleDomain2 = full_data2.map((d) => d.assessmentDate);
        }
      } catch (error) {
        console.error(error);
      }
      this.asessLoader = false;
    },
    cancelFilterSection() {
      this.overallReportsFilter = false;
    },
    getsearchedoverAll() {
      this.checkoverAllScrollLoader = true;
      this.overAllCustPage = 0;
      this.showOverAllLoader = true;
      this.getOverAllCustomers();
    },
    async getOverAllCustomers() {
      try {
        let payload = {
          page: this.overAllCustPage,
          order: this.overAllOrder,
          count: this.overAllCount,
          sortBy: this.overAllSort,
          searchQuery: this.overAllSearchQuery,
        };
        const res = await getCustomerReports(payload);
        if (res.status == 200) {
          if (this.overAllCustPage == 0) {
            this.overAllCustData = res.data.data.data;
          } else {
            this.overAllCustData = [
              ...this.overAllCustData,
              ...res.data.data.data,
            ];
          }
          this.overAllCustTotal = res.data.data.total;
          this.overAllCustPageEnd = res.data.data.pageEnd;
          this.checkoverAllScrollLoader = false;
          this.showOverAllLoader = false;
        }
      } catch (err) {
        console.error(err);
      }
    },
    resetFilter() {
      this.storeTypeSelected = "";
      this.jobType = "";
      this.mainFilter = false;
      this.statsPage = 0;
      this.statsMainLoader = true;
      this.getCustStats();
    },
    cancelFilter() {
      this.jobType = this.storeTypeSelected;
      this.mainFilter = false;
    },
    applyFilter() {
      this.appliedFilted = true;
      this.mainFilter = false;
      this.storeTypeSelected = this.jobType;
      this.statsPage = 0;
      this.statsMainLoader = true;
      this.getCustStats();
    },
    sortCustStatsData(sort, order) {
      this.checkStatsScroll = true;
      this.statsSort = sort;
      this.statsOrder = order;
      this.statsPage = 0;
      this.statsMainLoader = true;
      this.getCustStats();
    },
    updateJobsData() {
      this.checkStatsScroll = true;
      this.statsPage = 0;
      this.statsMainLoader = true;
      this.getCustStats();
    },
    async getCustStats() {
      try {
        let payload = {
          count: this.statsCount,
          page: this.statsPage,
          sortBy: this.statsSort,
          order: this.statsOrder,
          searchQuery: this.statsSearchQuery,
          timeline: this.timeline,
          startDate: this.convertDateFormat(this.fromDate),
          endDate: this.convertDateFormat(this.toDate),
          startTime: this.startTime,
          endTime: this.endTime,
        };
        if (this.jobType !== "") {
          payload.typeOfJob = this.jobType;
        }
        if (this.selectedCustID !== "") {
          payload.customerID = this.selectedCustID;
        }

        const res = await getCustomerStats(payload);
        if (res.status == 200) {
          if (this.statsPage == 0) {
            this.statsData = res.data.data.data;
          } else {
            this.statsData = [...this.statsData, ...res.data.data.data];
          }
          this.statsTotal = res.data.data.total;
          this.statsPageEnd = res.data.data.pageEnd;
          this.checkStatsScroll = false;
          this.totalJobsCount = res.data.data.totalJobs;
          this.statsMainLoader = false;
        }
      } catch (err) {
        console.error(err);
      }
    },
    statsScroll(e) {
      const { target } = e;
      if (
        Math.ceil(target.scrollTop) >=
        target.scrollHeight - target.offsetHeight
      ) {
        if (
          this.checkbetween(this.statsPageEnd, 0, this.statsTotal) &&
          !this.checkStatsScroll
        ) {
          this.checkStatsScroll = true;
          this.statsPage++;
          this.getCustStats();
        }
      }
    },

    scrollOverAllCust(e) {
      const { target } = e;
      if (
        Math.ceil(target.scrollTop) >=
        target.scrollHeight - target.offsetHeight
      ) {
        if (
          this.checkbetween(
            this.overAllCustPageEnd,
            0,
            this.overAllCustTotal
          ) &&
          !this.checkoverAllScrollLoader
        ) {
          this.checkoverAllScrollLoader = true;
          this.overAllCustPage++;
          this.getOverAllCustomers();
        }
      }
    },
    SelectOverallRow(name, customerID) {
      this.selectedRow = customerID;
      this.selectedRowName = name;
      this.selectedCustID = customerID;
      this.custPage = 0;
      this.statsPage = 0;
      this.statsMainLoader = true;
      this.getCustStats();
      this.overAllSearchQuery = "";
      this.overallReportsFilter = false;
      this.selectionCustomerReports();
      this.sourceCustomerReport();
      this.assessmentTakenGraph();
    },

    SelectRow(name, customerID) {
      if (this.selectedRow === customerID) {
        this.selectedRow = "all";
        this.selectedRowName = "";
        this.selectedCustID = "";
      } else {
        this.selectedRow = customerID;
        this.selectedRowName = name;
        this.selectedCustID = customerID;
      }
      this.custPage = 0;
      this.statsPage = 0;
      this.statsMainLoader = true;
      this.getCustStats();
      this.overAllSearchQuery = "";
      this.overallReportsFilter = false;
      this.selectionCustomerReports();
      this.sourceCustomerReport();
      this.assessmentTakenGraph();
      this.scrollToDiv();
    },
    selectAllCustRow() {
      this.selectedRow = "all";
      this.selectedCustID = "";
      this.custPage = 0;
      this.statsMainLoader = true;
      this.getCustStats();
      this.overAllSearchQuery = "";
      this.overallReportsFilter = false;
      this.selectionCustomerReports();
      this.sourceCustomerReport();
      this.assessmentTakenGraph();
    },
    cancelCustom() {
      this.fromDate = this.storeFromDate;
      this.toDate = this.storeToDate;
      this.startTime = this.storeStartTime;
      this.endTime = this.storeEndTime;
      this.durationListOpen = false;
      this.customDurationOpen = false;
      if (!this.appliedFilter) {
        this.appliedFilter = false;
      }
    },
    resetCustom() {
      this.storeFromDate = "";
      this.storeToDate = "";
      this.storeStartTime = "";
      this.storeEndTime = "";
      this.fromDate = "";
      this.toDate = "";
      this.startTime = "";
      this.endTime = "";
      this.timeline = "thisMonth";
      this.storeTimeline = "thisMonth";
      this.statsMainLoader = true;
      this.statsPage = 0;
      this.getCustStats();
      this.durationListOpen = false;
      this.customDurationOpen = false;
      this.appliedFilter = false;
    },
    applyCustom() {
      this.appliedFilter = true;
      this.storeFromDate = this.fromDate;
      this.storeToDate = this.toDate;
      this.storeStartTime = this.startTime;
      this.storeEndTime = this.endTime;
      this.statsMainLoader = true;
      this.statsPage = 0;
      this.getCustStats();
      this.durationListOpen = false;
      this.customDurationOpen = false;
      this.selectionCustomerReports();
      this.sourceCustomerReport();
      this.assessmentTakenGraph();
      this.storeTimeline = "custom";
      this.timeline = "custom";
    },
    setTimeline(value) {
      this.timeline = value;
      if (this.timeline !== "custom") {
        this.statsMainLoader = true;
        this.statsPage = 0;
        this.getCustStats();
        this.durationListOpen = false;
        this.customDurationOpen = false;
        this.storeFromDate = "";
        this.storeToDate = "";
        this.storeStartTime = "";
        this.storeEndTime = "";
        this.fromDate = "";
        this.toDate = "";
        this.startTime = "";
        this.endTime = "";
        this.appliedFilter = false;
        this.selectionCustomerReports();
        this.sourceCustomerReport();
        this.assessmentTakenGraph();
        this.storeTimeline = this.timeline;
      }
    },
    goBack() {
      if (this.$route.query.status == "dashboard") {
        this.$router.push({
          name: "MainDashboard",
        });
      } else {
        this.$router.push({
          name: "ReportDashboard",
        });
      }
    },
    custScroll(e) {
      const { target } = e;
      if (
        Math.ceil(target.scrollTop) >=
        target.scrollHeight - target.offsetHeight
      ) {
        if (
          this.checkbetween(this.custPageEnd, 0, this.custTotal) &&
          !this.checkCustScroll &&
          this.customerData.length != 0
        ) {
          this.checkCustScroll = true;
          this.custPage++;
          this.getCustData();
        }
      }
    },
    checkbetween(x, min, max) {
      return x > min && x < max;
    },
    getSearchCustData() {
      this.checkCustScroll = true;
      this.custPage = 0;
      this.custMainLoader = true;
      this.getCustData();
    },
    sortData(sort, order) {
      this.custSort = sort;
      this.custOrder = order;
      this.custPage = 0;
      this.checkCustScroll = true;
      this.custMainLoader = true;
      this.getCustData();
    },
    async getCustData() {
      try {
        let payload = {
          count: this.custCount,
          page: this.custPage,
          sortBy: this.custSort,
          order: this.custOrder,
          searchQuery: this.custSearchQuery,
        };
        const res = await getCustomerReports(payload);
        if (res.status == 200) {
          this.LoaderStatus = false;
          if (this.custPage == 0) {
            this.customerData = res.data.data.data;
          } else {
            this.customerData = [...this.customerData, ...res.data.data.data];
          }
          this.custTotal = res.data.data.total;
          this.custPageEnd = res.data.data.pageEnd;
          this.checkCustScroll = false;
          this.totalCustCount = res.data.data.totalCustomerCount;
          this.totalJobCount = res.data.data.totalJobsCount;
          this.totalOpeningsCount = res.data.data.totalOpeningsCount;
          this.totalSelectedCount = res.data.data.totalSelectedCandidatesCount;
          this.custMainLoader = false;
          if (this.customerData && this.customerData.length != 0) {
            this.setUserIcon();
          }
        }
      } catch (err) {
        console.error(err);
      }
    },
    setUserIcon() {
      for (let i in this.customerData) {
        for (let j in this.customerData[i].coOrdinatorDetails) {
          if (this.customerData[i].coOrdinatorDetails[j].name.includes(" ")) {
            const first = this.customerData[i].coOrdinatorDetails[j].name
              .split(" ")[0][0]
              .toUpperCase();
            const sec = this.customerData[i].coOrdinatorDetails[j].name
              .split(" ")[1][0]
              .toUpperCase();
            this.customerData[i].coOrdinatorDetails[j].userIcon = first + sec;
          } else {
            const value = this.customerData[i].coOrdinatorDetails[j].name
              .slice(0, 2)
              .toUpperCase();
            this.customerData[i].coOrdinatorDetails[j].userIcon = value;
          }
        }
      }
    },
    toggleMainFilter() {
      this.mainFilter = !this.mainFilter;
      this.durationListOpen = false;
      this.customDurationOpen = false;
      this.overallReportsFilter = false;
    },
    closemainFilterClosableFilter() {
      this.mainFilter = false;
      this.jobTypeToggle = false;
      this.jobType = this.storeTypeSelected;
    },
    openDurationList() {
      this.durationListOpen = !this.durationListOpen;
      this.customDurationOpen = false;
      this.overallReportsFilter = false;
      this.mainFilter = false;
    },
    toggleReportsFilter() {
      this.overallReportsFilter = !this.overallReportsFilter;
      this.durationListOpen = false;
      this.customDurationOpen = false;
      this.mainFilter = false;
      this.overAllCustPage = 0;
      this.overAllCustData = [];
      this.showOverAllLoader = true;
      this.getOverAllCustomers();
    },
  },
};
</script>
<style scoped>
.new-reports {
  position: relative;
  padding: 15px 20px 0px 77px;
  top: 71px;
  height: calc(100vh - 71px);
  background-color: #e9ecef;
  overflow-y: scroll;
  font-family: "Lato", sans-serif;
}

.new-reports .new-reports-header {
  background-color: #f6f9fb;
  border-radius: 6px;
}

.new-reports .new-reports-header .title-nav {
  gap: 18px;
}

.new-reports .new-reports-header .title-nav .title {
  color: #20639b;
  font-weight: 600;
  font-size: 20px;
}

.daily-option {
  position: relative;
}

.daily-option .report-duration-dropdown {
  position: absolute;
  top: 33px;
  width: 125px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  box-shadow: 0 0 15px #82828290;
  z-index: 300;
  right: 0;
}

.daily-option .report-duration-dropdown .duration-item {
  transition: all 0.2s ease;
  font-size: 13px;
  font-weight: 500;
  padding: 8px 10px;
}

.daily-option .report-duration-dropdown .duration-item:hover {
  background-color: #e8eff4;
}

.daily-option .report-duration-dropdown .duration-item.custom {
  position: relative;
}

.custom-duration-menu {
  position: absolute;
  background: #ffffff;
  right: 95%;
  top: 10%;
  box-shadow: 0 0 15px #82828290;
  border-radius: 6px;
  width: 280px;
}

.custom-duration-menu .custom-title {
  font-weight: 600;
  font-size: 16px;
}

.custom-duration-menu form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.custom-button-field {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}

.custom-button-field button {
  padding: 4px 14px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 13px;
}

.custom-button-field button.cancel {
  color: #20639b;
  background-color: white;
  border: 2px solid #20639b;
}

.custom-button-field button.apply {
  color: white;
  background-color: #20639b;
  border: 2px solid #20639b;
}

.custom-duration-menu form .custom-input-field {
  display: flex;
  flex-direction: column;
}

.custom-duration-menu form .custom-input-field label {
  font-size: 14px;
}

.custom-duration-menu form .custom-input-field .date-picker-field {
  display: flex;
  align-items: center;
  padding: 6px 10px;
  border-radius: 10px;
  justify-content: space-between;
  width: 100%;
  border: 1px solid #a8a8a8;
}

.custom-duration-menu form .custom-input-field .date-picker-field span {
  color: #667085;
}

.daily-option > button {
  background-color: transparent;
  gap: 12px;
  color: #20639b;
  cursor: pointer;
  border: none;
}

.new-reports .overview-tab {
  background: #fff;
  margin-top: 10px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.new-reports .overview-tab .tab-title {
  font-weight: 600;
}

.new-reports .overview-tab .overview-items-flex {
  gap: 32px;
  justify-content: space-evenly;
  flex-wrap: wrap;
}

.new-reports .overview-tab .overview-items-flex .overview-item {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 12px;
  font-weight: 500;
}

.new-reports .overview-tab .overview-items-flex .overview-item .item-value {
  color: #20639b;
}

.new-reports .table-panel {
  background-color: #fff;
  border-radius: 6px;
  margin-top: 10px;
}

.new-reports .table-panel .table-title-bar {
  border-bottom: 1px solid #dddddd;
}

.new-reports .table-panel .table-title-bar .table-title {
  font-weight: 600;
}

.new-reports .table-panel .table-title-bar .search-export-options {
  gap: 18px;
  position: relative;
}

.new-reports
  .table-panel
  .table-title-bar
  .search-export-options
  .filter-popup {
  position: absolute;
  top: 100%;
  right: 0%;
  padding: 10px;
  border-radius: 10px;
  background-color: #fff;
  box-shadow: 0 0 15px #10101021;
  display: flex;
  flex-direction: column;
  gap: 12px;
  z-index: 300;
  width: 270px;
}

.new-reports
  .table-panel
  .table-title-bar
  .search-export-options
  .filter-popup
  label {
  font-size: 14px;
  font-family: "Montserrat", "sans-serif";
  font-weight: 500;
}

.new-reports
  .table-panel
  .table-title-bar
  .search-export-options
  .filter-popup
  select {
  margin-top: 5px;
  border-radius: 10px;
  padding: 5px;
  border: 1px solid #d0d5dd;
}

.new-reports
  .table-panel
  .table-title-bar
  .search-export-options
  .filter-popup
  .filter-options {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.new-reports
  .table-panel
  .table-title-bar
  .search-export-options
  .filter-popup
  .filter-options
  button {
  border-radius: 20px;
  background-color: #fff;
  border: 1px solid #20639b;
  color: #20639b;
  font-size: 11px;
  padding: 2px 10px;
  font-weight: 600;
}

.new-reports
  .table-panel
  .table-title-bar
  .search-export-options
  .filter-popup
  .filter-options
  .apply-reset {
  display: flex;
  align-items: center;
  gap: 10px;
}

.new-reports
  .table-panel
  .table-title-bar
  .search-export-options
  .active-customers {
  color: #72738e;
  font-size: 14px;
}

.new-reports .table-panel .table-title-bar .search-bar {
  /* gap: 12px; */
  background-color: #f4f4f6;
  width: max-content;
  border-radius: 20px;
}

.new-reports .table-panel .table-title-bar .search-bar input {
  background-color: transparent;
  border: none;
  height: 30px;
}

.new-reports .table-panel .table-title-bar .filter,
.new-reports .table-panel .table-title-bar .export-excel {
  outline: none;
  border: none;
  background-color: #20639b;
  color: white;
  border-radius: 20px;
  gap: 10px;
}

.new-reports .table-panel .table-container {
  position: relative;
}

.new-reports .table-panel.wide-table .table-container {
  overflow-x: scroll;
}

.new-reports .table-panel .table-container .table-pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.new-reports .table-panel .table-container .table-pagination > * {
  flex: 1;
}

.new-reports .table-panel.wide-table .table-container .table-pagination > * {
  width: 400px;
}

.new-reports .table-panel .table-container .table-pagination .go-to {
  gap: 12px;
}

.new-reports .table-panel .table-container .table-pagination .go-to span {
  font-size: 14px;
  color: #20639b;
}

.new-reports .table-panel .table-container .table-pagination .go-to input {
  width: 30px;
  font-size: 14px;
  border: 1px solid rgb(181, 181, 181);
}

.new-reports .table-panel .table-container .table-pagination .go-to img {
  cursor: pointer;
}

.new-reports .table-panel .table-container .table-pagination .page-scrub {
  gap: 12px;
}

.new-reports
  .table-panel
  .table-container
  .table-pagination
  .page-scrub
  .page-list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.new-reports .table-panel .table-container .table-pagination .page-scrub img {
  cursor: pointer;
}

.new-reports
  .table-panel
  .table-container
  .table-pagination
  .page-scrub
  .page-list
  .page-item {
  padding: 4px 8px;
  border-radius: 6px;
  color: #20639b;
  font-size: 14px;
  cursor: pointer;
}

.new-reports
  .table-panel
  .table-container
  .table-pagination
  .page-scrub
  .page-list
  .page-item.selected {
  background-color: #20639b;
  color: #fff;
}

.new-reports .table-panel .table-container .table-pagination .items-rows {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  font-size: 14px;
  color: #20639b;
}

.new-reports
  .table-panel
  .table-container
  .table-pagination
  .items-rows
  .rows-pp {
  gap: 10px;
}

.new-reports .table-panel .table-container .table-header {
  background-color: #e9f0f5;
  gap: 10px;
  display: flex;
  align-items: center;
}

.new-reports .table-panel.wide-table .table-container .table-header {
  width: max-content;
}

.new-reports .table-panel .table-container .table-header .header-item {
  font-size: 14px;
  font-weight: 600;
  color: #20639b;
  gap: 4px;
}

.new-reports
  .table-panel
  .table-container
  .table-header
  .header-item
  .sort-header {
  gap: 2px;
}

.new-reports
  .table-panel
  .table-container
  .table-header
  .header-item
  .sort-header
  img {
  cursor: pointer;
}

.new-reports .table-panel .table-container .table-header > * {
  flex: 1;
}

.new-reports .table-panel.wide-table .table-container .table-header > * {
  width: 250px;
}

.new-reports .table-panel .table-container .table-data-rows {
  margin-top: 10px;
  height: 300px;
  /* max-height: 365px; */
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.new-reports .table-panel.wide-table .table-container .table-data-rows {
  width: max-content;
}

.new-reports .table-panel .table-container .table-data-rows .data-row {
  background-color: #fff;
  display: flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 0 15px #dedede;
}

.new-reports .table-panel .table-container .table-data-rows .data-row.active {
  border-left: 3px solid #038e00;
}

.new-reports .table-panel .table-container .table-data-rows .data-row.closed {
  border-left: 3px solid #e70016;
}

.new-reports .table-panel .table-container .table-data-rows .data-row:hover {
  background-color: #e8eff4;
}

.new-reports .table-panel .table-container .table-data-rows .data-row > * {
  flex: 1;
  font-size: 15px;
  font-weight: 400;
  color: #20639b;
}

.new-reports
  .table-panel.wide-table
  .table-container
  .table-data-rows
  .data-row
  > * {
  width: 250px;
}

.new-reports .sourced-skills {
  margin-top: 10px;
  border-radius: 6px;
  background-color: #fff;
}

.new-reports .sourced-skills .source-title-bar {
  border-bottom: 1px solid #dddddd;
}

.new-reports .sourced-skills .source-title {
  font-weight: 600;
}

.new-reports .sourced-skills .skills-chips-flex {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.new-reports .sourced-skills .skills-chips-flex .chip {
  background-color: #eff6fb;
  color: #85a9c8;
  font-size: 14px;
  font-weight: 500;
}

.new-reports .sourced-skills .skills-chips-flex .chip.show-all {
  background-color: #85a9c8;
  color: #eff6fb;
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;
}

/* Overall Reports Section */

.new-reports .overall-reports {
  margin-top: 10px;
}

.new-reports .overall-reports .overall-reports-header .title-section .title {
  font-weight: 600;
}

.new-reports
  .overall-reports
  .overall-reports-header
  .title-section
  .sub-title {
  color: #888888;
  font-style: italic;
}

.new-reports .overall-reports .overall-reports-header .filter-section {
  gap: 10px;
}

.new-reports
  .overall-reports
  .overall-reports-header
  .filter-section
  .custom-dropdown {
  position: relative;
  font-size: 14px;
}

.new-reports
  .overall-reports
  .overall-reports-header
  .filter-section
  .custom-dropdown
  .selected-filter {
  background-color: transparent;
  gap: 12px;
  color: #20639b;
  cursor: pointer;
}

.new-reports
  .overall-reports
  .overall-reports-header
  .filter-section
  .custom-dropdown
  .filter-list-dropdown {
  position: absolute;
  right: 0;
  top: 30px;
  background-color: #fff;
  z-index: 300;
  border-radius: 6px;
  box-shadow: 0 0 15px #10101047;
}

.new-reports
  .overall-reports
  .overall-reports-header
  .filter-section
  .custom-dropdown
  .filter-list-dropdown
  .filter-search {
  background-color: #f1f1f1;
  display: flex;
  align-items: center;
  padding: 2px 10px;
  gap: 10px;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}

.new-reports
  .overall-reports
  .overall-reports-header
  .filter-section
  .custom-dropdown
  .filter-list-dropdown
  .filter-search
  input {
  background-color: #f1f1f1;
  border: none;
}

.new-reports
  .overall-reports
  .overall-reports-header
  .filter-section
  .custom-dropdown
  .filter-list-dropdown
  .filter-list {
  display: flex;
  flex-direction: column;
  min-height: auto;
  max-height: 165px;
  overflow-y: scroll;
}

.new-reports
  .overall-reports
  .overall-reports-header
  .filter-section
  .custom-dropdown
  .filter-list-dropdown
  .filter-list
  > * {
  padding: 10px;
  cursor: pointer;
}

.new-reports .overall-reports .overall-reports-flex {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
}

.new-reports .overall-reports .overall-reports-flex > * {
  flex: 1;
}

.new-reports .overall-reports .overall-reports-flex .overall-reports-item {
  background-color: #fff;
  border-radius: 6px;
}

.new-reports
  .overall-reports
  .overall-reports-flex
  .overall-reports-item
  .report-title {
  border-bottom: 1px solid #dddddd;
}

.new-reports
  .overall-reports
  .overall-reports-flex
  .overall-reports-item
  .report-title
  .sub-title {
  font-size: 12px;
  color: #72738e;
}

.new-reports
  .overall-reports
  .overall-reports-flex
  .overall-reports-item
  .report-content {
  position: relative;
  min-height: 250px;
}

.new-reports
  .overall-reports
  .overall-reports-flex
  .overall-reports-item
  .report-content
  .sample-legend {
  border-radius: 10px;
  border: 1px solid black;
  padding: 10px;
  width: max-content;
  position: absolute;
  bottom: 25px;
  right: 25px;
}

.new-reports
  .overall-reports
  .overall-reports-flex
  .overall-reports-item
  .report-content
  .sample-legend-selection {
  border-radius: 10px;
  border: 1px solid black;
  padding: 10px;
  width: max-content;
  position: absolute;
  top: 15px;
  right: 25px;
}

.new-reports
  .overall-reports
  .overall-reports-flex
  .overall-reports-item
  .report-content
  .sample-legend
  .legend-item {
  gap: 10px;
  font-size: 11px;
}

.new-reports
  .overall-reports
  .overall-reports-flex
  .overall-reports-item
  .report-content
  .sample-legend-selection
  .legend-item {
  gap: 10px;
  font-size: 11px;
}

.new-reports
  .overall-reports
  .overall-reports-flex
  .overall-reports-item
  .report-content
  .sample-legend
  .legend-item
  .color-disc {
  height: 6px;
  aspect-ratio: 1/1;
  border-radius: 100%;
}

.new-reports
  .overall-reports
  .overall-reports-flex
  .overall-reports-item
  .report-content
  .sample-legend-selection
  .legend-item
  .color-disc {
  height: 6px;
  aspect-ratio: 1/1;
  border-radius: 100%;
}

/* Overall Reports Section End*/

@media screen and (max-width: 1024px) {
  .new-reports {
    padding: 15px 20px 0px 20px;
  }
}

.roundDarkBlue {
  width: 30px;
  height: 30px;
  background-color: #20639b;
  border: 1px solid white;
  border-radius: 50%;
  font-size: 10px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
}

.roundLightBlue {
  width: 30px;
  height: 30px;
  background-color: #e9f0f5;
  border: 1px solid white;
  border-radius: 50%;
  font-size: 10px;
  color: #20639b;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
}

.assesGraph {
  overflow-x: auto;
  overflow-y: hide;
}
</style>
